<button
  type="button"
  class="badge toggle-badge"
  [class.active]="active"
  [disabled]="disabled"
  (click)="handleClick()">
  <ng-content></ng-content>
</button>
